import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles<{ minWidth?: number }>()((theme, { minWidth }) => ({
  modal: { display: "flex", alignItems: "center", justifyContent: "center" },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
    padding: `${theme.spacing(2)} ${theme.spacing(4)} !important`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  paper: { borderRadius: theme.shape.borderRadius, minWidth: minWidth ?? "auto" },
}));

export default useStyles;
